module.exports = __webpack_public_path__ + "img/Weak Prong.fe2801ea.png";